import HInput from './input'
export { default as HInput } from './input'
import HTextarea from './textarea'
export { default as HTextarea } from './textarea'
import HPhone from './phone'
export { default as HPhone } from './phone'
import HPassword from './password'
export { default as HPassword } from './password'

import HRadio from './radio'
export { default as HRadio } from './radio'
import HCheckbox from './checkbox'
export { default as HCheckbox } from './checkbox'
import HSelect from './select'
export { default as HSelect } from './select'
import HTimePicker from './time-picker'
export { default as HTimePicker } from './time-picker'
import HTimePickerMultiple from './time-picker-multiple'
export { default as HTimePickerMultiple } from './time-picker-multiple'
import HDatePicker from './date-picker'
export { default as HDatePicker } from './date-picker'
import HDatePickerMultiple from './date-picker-multiple'
export { default as HDatePickerMultiple } from './date-picker-multiple'

import HRate from './rate'
export { default as HRate } from './rate'
import HSwitch from './switch'
export { default as HSwitch } from './switch'
import HInputNumber from './input-number'
export { default as HInputNumber } from './input-number'

import HLink from './link'
export { default as HLink } from './link'
import HDivider from './divider'
export { default as HDivider } from './divider'
import HLayout from './layout'
export { default as HLayout } from './layout'

import HInputSetting from './input/setting'
export { default as HInputSetting } from './input/setting'

import HTextareaSetting from './textarea/setting'
export { default as HTextareaSetting } from './textarea/setting'
import HPhoneSetting from './phone/setting'
export { default as HPhoneSetting } from './phone/setting'
import HPasswordSetting from './password/setting'
export { default as HPasswordSetting } from './password/setting'
import HRadioSetting from './radio/setting'
export { default as HRadioSetting } from './radio/setting'
import HCheckboxSetting from './checkbox/setting'
export { default as HCheckboxSetting } from './checkbox/setting'
import HSelectSetting from './select/setting'
export { default as HSelectSetting } from './select/setting'
import HTimePickerSetting from './time-picker/setting'
export { default as HTimePickerSetting } from './time-picker/setting'
import HTimePickerMultipleSetting from './time-picker-multiple/setting'
export { default as HTimePickerMultipleSetting } from './time-picker-multiple/setting'
import HDatePickerSetting from './date-picker/setting'
export { default as HDatePickerSetting } from './date-picker/setting'
import HDatePickerMultipleSetting from './date-picker-multiple/setting'
export { default as HDatePickerMultipleSetting } from './date-picker-multiple/setting'
import HRateSetting from './rate/setting'
export { default as HRateSetting } from './rate/setting'
import HSwitchSetting from './switch/setting'
export { default as HSwitchSetting } from './switch/setting'
import HInputNumberSetting from './input-number/setting'
export { default as HInputNumberSetting } from './input-number/setting'
import HLinkSetting from './link/setting'
export { default as HLinkSetting } from './link/setting'
import HDividerSetting from './divider/setting'
export { default as HDividerSetting } from './divider/setting'
import HLayoutSetting from './layout/setting'
export { default as HLayoutSetting } from './layout/setting'

const formElements = {
  HInput,
  HTextarea,
  HPhone,
  HPassword,

  HRadio,
  HCheckbox,
  HSelect,
  HTimePicker,
  HTimePickerMultiple,
  HDatePicker,
  HDatePickerMultiple,

  HRate,
  HSwitch,
  HInputNumber,

  HLink,
  HDivider,
  HLayout
}

const settingElements = {
  HInputSetting,
  HTextareaSetting,
  HPhoneSetting,
  HPasswordSetting,

  HRadioSetting,
  HCheckboxSetting,
  HSelectSetting,
  HTimePickerSetting,
  HTimePickerMultipleSetting,
  HDatePickerSetting,
  HDatePickerMultipleSetting,

  HRateSetting,
  HSwitchSetting,
  HInputNumberSetting,

  HLinkSetting,
  HDividerSetting,
  HLayoutSetting
}

export default {
  ...formElements,
  ...settingElements
}
